module.exports = __webpack_public_path__ + "static/media/2021-zz.4a993e53.jpg";